module.exports = __webpack_public_path__ + "static/media/3.195f9d46.jpg";